import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaBug, FaHome } from 'react-icons/fa';

const NotFoundPage = () => {
  return (
    <motion.div 
      className="d-flex align-items-center justify-content-center min-vh-100 bg-light"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="text-center p-5 bg-white rounded-3 shadow" style={{ maxWidth: '600px', width: '90%' }}>
        <motion.div
          animate={{ 
            y: [0, -10, 0],
            rotate: [0, 10, -10, 0]
          }}
          transition={{ 
            duration: 2, 
            repeat: Infinity,
            repeatType: "reverse" 
          }}
        >
          <FaBug className="text-danger" style={{ fontSize: '5rem' }} />
        </motion.div>
        
        <h1 className="display-4 fw-bold text-danger mt-4">404</h1>
        <h2 className="h3 mb-4">Oops! Page Not Found</h2>
        
        <p className="lead mb-4">
          The page you're looking for seems to have been eaten by bugs! 
          Don't worry, we'll help you get back on track.
        </p>
        
        <Link 
          to="/" 
          className="btn btn-danger btn-lg px-4 py-2 d-inline-flex align-items-center"
        >
          <FaHome className="me-2" />
          Back to Home
        </Link>
      </div>
    </motion.div>
  );
};

export default NotFoundPage;
